<template>
  <b-modal
    v-model="visible"
    title="Terms and Conditions"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    ok-only
    ok-title="Accept"
    @ok="accept"
  >
    <p>
      By using this application you agree to our
      <a
        :href="termsUrl"
        target="_blank"
      >Terms and Conditions</a>
      and
      <a
        :href="privacyPolicyUrl"
        target="_blank"
      >Privacy Policy</a>.
    </p>
  </b-modal>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import appConfig from '@/config'

const STORAGE_KEY = 'termsAccepted'

@Component
export default class TermsModal extends Vue {
  visible: boolean = false

  get termsUrl() {
    return appConfig.termsUrl
  }

  get privacyPolicyUrl() {
    return appConfig.privacyPolicyUrl
  }

  mounted(): void {
    if (!localStorage.getItem(STORAGE_KEY)) {
      this.visible = true
    }
  }

  accept(): void {
    localStorage.setItem(STORAGE_KEY, 'true')
    this.visible = false
  }
}
</script>
